import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import {
  ApartmentOutline,
  AppstoreOutline,
  ArrowDownOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  ArrowUpOutline,
  AudioMutedOutline,
  AuditOutline,
  BellOutline,
  BookOutline,
  BorderOutline,
  CalculatorOutline,
  CalendarOutline,
  CameraOutline,
  CarOutline,
  CheckCircleFill,
  CheckCircleOutline,
  CheckOutline,
  CheckSquareOutline,
  ClockCircleOutline,
  CloseCircleOutline,
  CloseOutline,
  CloudDownloadOutline,
  CoffeeOutline,
  ColumnHeightOutline,
  ContainerOutline,
  CreditCardOutline,
  DashboardOutline,
  DatabaseOutline,
  DeleteOutline,
  DisconnectOutline,
  DollarOutline,
  DownOutline,
  DownloadOutline,
  EditOutline,
  EnvironmentFill,
  EnvironmentOutline,
  EuroOutline,
  ExclamationCircleOutline,
  ExperimentOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FallOutline,
  FileOutline,
  FilePdfOutline,
  FileProtectOutline,
  FileTextOutline,
  FireOutline,
  FormOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  GiftOutline,
  GlobalOutline,
  HistoryOutline,
  HolderOutline,
  HomeOutline,
  InboxOutline,
  InfoCircleOutline,
  LeftOutline,
  LineChartOutline,
  LinkOutline,
  LoadingOutline,
  LockOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuOutline,
  MenuUnfoldOutline,
  MessageOutline,
  MinusOutline,
  MoreOutline,
  OrderedListOutline,
  PaperClipOutline,
  PartitionOutline,
  PercentageOutline,
  PhoneOutline,
  PictureOutline,
  PlayCircleOutline,
  PlusCircleOutline,
  PlusOutline,
  PrinterOutline,
  ProfileOutline,
  QrcodeOutline,
  ReadOutline,
  ReconciliationOutline,
  RedoOutline,
  ReloadOutline,
  RestOutline,
  RightOutline,
  RiseOutline,
  RocketOutline,
  RollbackOutline,
  SafetyCertificateOutline,
  SaveOutline,
  ScheduleOutline,
  SearchOutline,
  SendOutline,
  SoundOutline,
  SettingOutline,
  ShareAltOutline,
  ShoppingCartOutline,
  ShoppingOutline,
  StarOutline,
  StopOutline,
  SwapOutline,
  TableOutline,
  TagOutline,
  TeamOutline,
  ThunderboltOutline,
  ToolOutline,
  TrophyOutline,
  UndoOutline,
  UnlockOutline,
  UnorderedListOutline,
  UpOutline,
  UploadOutline,
  UserDeleteOutline,
  UserOutline,
  UsergroupAddOutline,
  WalletOutline,
  WarningOutline,
} from '@ant-design/icons-angular/icons';
import { NzIconModule } from 'ng-zorro-antd/icon';

// Every icon the templates reference must be registered statically: an
// unregistered one is fetched from `/assets/<theme>/<name>.svg` at runtime,
// which the service worker does not precache — it would render blank offline.
const icons = [
  ApartmentOutline,
  AppstoreOutline,
  ArrowDownOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  ArrowUpOutline,
  AudioMutedOutline,
  AuditOutline,
  BellOutline,
  BookOutline,
  BorderOutline,
  CalculatorOutline,
  CalendarOutline,
  CameraOutline,
  CarOutline,
  CheckCircleFill,
  CheckCircleOutline,
  CheckOutline,
  CheckSquareOutline,
  ClockCircleOutline,
  CloseCircleOutline,
  CloseOutline,
  CloudDownloadOutline,
  CoffeeOutline,
  ColumnHeightOutline,
  ContainerOutline,
  CreditCardOutline,
  DashboardOutline,
  DatabaseOutline,
  DeleteOutline,
  DisconnectOutline,
  DollarOutline,
  DownOutline,
  DownloadOutline,
  EditOutline,
  EnvironmentFill,
  EnvironmentOutline,
  EuroOutline,
  ExclamationCircleOutline,
  ExperimentOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FallOutline,
  FileOutline,
  FilePdfOutline,
  FileProtectOutline,
  FileTextOutline,
  FireOutline,
  FormOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  GiftOutline,
  GlobalOutline,
  HistoryOutline,
  HolderOutline,
  HomeOutline,
  InboxOutline,
  InfoCircleOutline,
  LeftOutline,
  LineChartOutline,
  LinkOutline,
  LoadingOutline,
  LockOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuOutline,
  MenuUnfoldOutline,
  MessageOutline,
  MinusOutline,
  MoreOutline,
  OrderedListOutline,
  PaperClipOutline,
  PartitionOutline,
  PercentageOutline,
  PhoneOutline,
  PictureOutline,
  PlayCircleOutline,
  PlusCircleOutline,
  PlusOutline,
  PrinterOutline,
  ProfileOutline,
  QrcodeOutline,
  ReadOutline,
  ReconciliationOutline,
  RedoOutline,
  ReloadOutline,
  RestOutline,
  RightOutline,
  RiseOutline,
  RocketOutline,
  RollbackOutline,
  SafetyCertificateOutline,
  SaveOutline,
  ScheduleOutline,
  SearchOutline,
  SendOutline,
  SoundOutline,
  SettingOutline,
  ShareAltOutline,
  ShoppingCartOutline,
  ShoppingOutline,
  StarOutline,
  StopOutline,
  SwapOutline,
  TableOutline,
  TagOutline,
  TeamOutline,
  ThunderboltOutline,
  ToolOutline,
  TrophyOutline,
  UndoOutline,
  UnlockOutline,
  UnorderedListOutline,
  UpOutline,
  UploadOutline,
  UserDeleteOutline,
  UserOutline,
  UsergroupAddOutline,
  WalletOutline,
  WarningOutline,
];

export function provideNzIcons(): EnvironmentProviders {
  return importProvidersFrom(NzIconModule.forRoot(icons));
}
